<template>
  <div class="loginAll">
    <div class="login">
      <div class="login_top ovh">
        <div class="f_l login_top_img">
          <img src="../../static/loginTop.png" />
        </div>
        <div class="f_r close" @click="close()">
          <img src="../../static/close.png" />
        </div>
      </div>
      <!-- 框 -->
      <div class="frame">
        <!-- tab选项 -->
        <div class="tabListAll tab ovh">
          <div v-for="(item, idnex) in tabList" :key="idnex" class="tabList f_l" :class="[tabCode == item.code ? 'tabListSelect' : '']" @click="tabClick(item)">
            {{item.name}}
            <div v-if="tabCode == item.code" class="tabList_select" :class="[tabCode == item.code ? 'tabList_select' : '']"></div>
          </div>
        </div>
        <!-- 输入框(验证码登录) -->
        <div class="inputAll" v-if="tabCode == 0">
          <input class="input" placeholder="请输入手机号" v-model="tel_1" maxlength="11" />
          <div class="input ovh">
            <input class="input_code f_l" placeholder="请输入验证码" v-model="code" />
            <div class="input_time f_r" @click="getCode">{{timeTxt}}</div>
          </div>
        </div>
        <!-- 输入框(账号密码登录) -->
        <div class="inputAll" v-if="tabCode == 1">
          <input class="input" placeholder="请输入账号" v-model="tel_2" maxlength="11" />
          <input class="input" placeholder="请输入密码" type="password" v-model="pwd" />
        </div>
        <!-- 隐私协议 -->
        <div class="agreement ovh">
          <input class="f_l checkbox" type="checkbox" v-model="agreementChecked" />
          <div class="agreementTxt f_l">
            我已阅读并同意乐冰雪的<span @click="seeAgreement(0)">《用户服务协议》</span>与<span @click="seeAgreement(1)">《隐私协议》</span>
          </div>
        </div>
        <!-- 按钮 -->
        <div class="button" @click="login">登录</div>
        <!-- 注册 -->
        <div class="bottom_size" @click="register">注册</div>
      </div>
    </div>
    <!-- 隐私协议 -->
    <mall-agreement v-if="agreementVisble" ref="agreement" @agreementReturn="agreementReturn"></mall-agreement>
  </div>
</template>

<script>
  // 引入共用的css
	import "../components/css/component.css";
  import "../components/css/input.css";

  // 隐私协议
  import MallAgreement from '@/components/agreement.vue';

  // 调用的接口
  import { codeLogin, pwdLogin, getPhoneCode } from '@/request/api.js';
  import { isMobile } from '@/utils/utils.js'

  export default {
    name: 'login',
    data () {
      return {
        tabCode: 0, // 0：验证码登录  1：账号密码登录
        tabList: [{
          code: 0,
          name: '验证码登录'
        }, {
          code: 1,
          name: '账号密码登录'
        }],
        tel_1: '', // 手机号/邮箱
        code: '', // 验证码
        tel_2: '', // 手机号/邮箱
        pwd: '', // 密码
        time: 60, // 倒计时
        timeTxt: '获取验证码', // 倒计时后缀
        agreementChecked: false, // 用户是否同意隐私协议
        agreementVisble: false // 隐私协议弹框
      }
    },

    mounted() {
      
    },

    components: {
      'mall-agreement': MallAgreement // 隐私协议
    },

    computed:{
      
    },

    methods:{
      // 进入页面执行的操作
      init() {
        
      },

      // 登录
      login() {
        // 判断用户是否同意隐私协议
        if(!this.agreementChecked) {
          this.$message({
            showClose: true,
            message: '请阅读并同意隐私协议'
          });
          return;
        }
        // 判断当前的登录是验证码登录还是验证码登录
        if(this.tabCode == 0) {
          // 验证码登录
          // 非空判断
          if(this.tel_1 == '') {
            this.$message({
              showClose: true,
              message: '请填写手机号/邮箱'
            });
            return;
          }
          if(this.code == '') {
            this.$message({
              showClose: true,
              message: '请填写验证码'
            });
            return;
          }
          if (!isMobile(this.tel_1)) {
            this.$message({
              showClose: true,
              message: '手机号格式错误'
            });
            return
          }
          // 调用手机号验证码登录
          codeLogin({
            phone: this.tel_1, // 手机号
            code: this.code // 验证码
          }).then(res => {
            if(res.code === 0) {
              this.$message({
                type: 'success',
                message: '登录成功'
              });
              // 保存用户信息
              localStorage.setItem('userName', res.data.nickname);
              localStorage.setItem('token', res.data.token);
              // 弹框消失
              this.close(0);
            }else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          })
        }else if(this.tabCode == 1) {
          // 账号密码登录
          if(this.tel_2 == '') {
            this.$message({
              showClose: true,
              message: '请填写账号'
            });
            return;
          }
          if(this.pwd == '') {
            this.$message({
              showClose: true,
              message: '请填写密码'
            });
            return;
          }
          // 调用账号密码登录
          pwdLogin({
            phone: this.tel_2, // 手机号
            password: this.pwd // 验证码
          }).then(res => {
            if(res.code === 0) {
              this.$message({
                type: 'success',
                message: '登录成功'
              });
              // 保存用户信息
              localStorage.setItem('userName', res.data.nickname);
              localStorage.setItem('token', res.data.token);
              // 弹框消失
              this.close(0);
            }else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          })
        }
      },

      // 获取验证码
      getCode() {
        // 判断当前倒计时是否走完
        if(this.timeTxt !== '重新获取' && this.timeTxt !== '获取验证码') {
          this.$message({
            message: '请倒计时完成后再试'
          });
          return;
        }
        // 调用根据手机号获取验证码接口
        getPhoneCode({
          phone: this.tel_1 // 手机号
        }).then(res => {
          if(res.code === 0) {
            this.$message({
              type: 'success',
              message: '发送成功'
            });
            // 倒计时
            this.setTimeCount();
          }else {
            this.$message({
              type: 'error',
              message: res.message
            });
          }
        })
      },

      // 倒计时
      setTimeCount() {
        var time = this.time;
        var timeText = '';
        time--;
        if (time <= 0) {
          this.time = 60; // 时间赋值
          this.timeTxt =  '重新获取'; // 内容赋值
          return;
        }
        this.time = time; // 时间赋值
        this.timeTxt =  time + '秒'; // 内容赋值
        setTimeout(this.setTimeCount, 1000);
      },

      // 点击tab切换
      tabClick(e) {
        this.tabCode = e.code;
      },

      // 注册
      register() {
        this.close(1)
      },

      // 关闭弹框
      close(code) {
        // 执行父组件的方法
        this.$emit('loginReturn', code)
      },


      // 点击协议
      seeAgreement(code) {
        var url = window.location.href;
        var index = url.lastIndexOf("\/");
        var str = url.substring(0, index + 1);
        localStorage.setItem('agreementCode', code)
        window.open(str + 'agreement');
        // 协议弹框出现
        // this.agreementVisble = true;
        // this.$nextTick(() => {
        //   this.$refs.agreement.init()
        // })
      },

      // 隐私协议弹框关闭
      agreementReturn() {
        // 协议弹框出现
        this.agreementVisble = false;
      }
    }
  }
</script>

<!-- 样式 -->
<style scoped lang="scss">
  .loginAll {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0,0,0,.5);
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    // 框
    .login {
      width: 644px;
      height: 456px;
      background-color: #FFFFFF;
      border-radius: 8px;
      &> .login_top {
        height: 70px;
        lin-height: 70px;
        background-color: #FF7702;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        padding: 0 16px;
        &> .login_top_img {
          width: 565px;
          height: 24px;
          margin: 23px 0 0 10px;
        }
        &> .close {
          width: 24px;
          height: 24px;
          font-size: 25px;
          line-height: 70px;
          margin-top: 3px;
          cursor: pointer;
        }
      }
      // 框
      &> .frame {
        width: 344px;
        margin: 0 auto;
        padding: 39px 0 0 0;
        // tab选项
        &> .tabListAll {
          &> .tabList {
            width: 50%;
            font-size: 18px;
            font-weight: 400;
            font-family: PingFangSC-Regular, PingFang SC;
            letter-spacing: 1px;
            cursor: pointer;
            color: #BFC0C0;
            // tab下划线选中
            &> .tabList_select {
              width: 80px;
              height: 4px;
              background: #0F7DFF;
              border-radius: 2px;
              margin: 5px auto;
            }
          }
          &> .tabListSelect {
            color: #434444;
          }
        }
        // 隐私协议
        &> .agreement {
          width: 100%;
          margin-top: 28px;
          &> .checkbox {
            margin: 2px 8px 0 0;
          }
          &> .agreementTxt {
            font-size: 12px;
            color: #7F7E7D;
            & span {
              color: #0F7DFF;
            }
          }
        }
        // 按钮
        &> .button {
          color: #fff;
          background-color: #0F7DFF;
          width: 344px;
          height: 56px;
          line-height: 56px;
          border-radius: 8px;
          margin: 12px 0 0 0;
        }
        // 注册
        &> .bottom_size {
          text-align: center;
          line-height: 40px;
          color: #0F7DFF;
          letter-spacing: 1px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
        }
      }
    }
  }
  .input {
    font-size: 14px;
    width: 310px;
    height: 56px;
    line-height: 56px;
    border-radius: 8px;
    background: #E2E2E2;
    padding: 0 17px;
    // box-sizing: border-box;
    letter-spacing: 1px;
    margin-top: 22px;
  }
  .input_code {
    width: 50%;
    height: 56px;
    line-height: 56px;
    font-size: 14px;
    letter-spacing: 1px;
  }
  .input_time {
    width: 80px;
    color: #0F7DFF;
  }
  input {
    -webkit-text-fill-color: #434444;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue